export const SELECTION = "SELECTION";
export const DUPLICATE = "DUPLICATE";
export const DELETE = "DELETE";
export const SUCCESS = "SUCCESS";
export const COMMERCIAL_SETTINGS = "COMMERCIALSETTINGS";
export const ADD_CONNECTION_SETTINGS = "ADDCONNECTIONSETTINGS";
export const SHOW_CONNECTIONS = "SHOWCONNECTIONS";
export const EDIT_CONNECTION_SETTINGS = "EDITCONNECTIONSETTINGS";
